module.exports = __webpack_public_path__ + "static/media/new-all3d-black.a51f0e40.svg";